"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.echoCommand = void 0;
const types_1 = require("../types");
exports.echoCommand = {
    name: 'echo',
    func: ({ sendToStdout }, args) => __awaiter(void 0, void 0, void 0, function* () {
        sendToStdout({
            message: args.join(' '),
            type: types_1.TerminalMessageType.Message,
        });
    }),
};
//# sourceMappingURL=echo.js.map